module.exports = __webpack_public_path__ + "img/Capacitacao_em_Informatica_Basica.a59125f4.jpg";